import PropTypes from 'prop-types';
import React from 'react';

export const userDisplayProps = {
    /**
     * Creator's Username
     * */
    username: PropTypes.string.isRequired,
    /**
     * Image Sizes
     * */
    image: PropTypes.shape({
        /**
         * Image Source (Cloudinary Id)
         * */
        src: PropTypes.string,
        /**
         * Image Alt
         * */
        alt: PropTypes.string,
    }),
    /**
     * Image Sizes
     * */
    imageSize: PropTypes.number,
    /**
     * Image Sizes
     * */
    customText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export const defaultUserDisplayProps = {
    /**
     * Image Source (Cloudinary Id)
     * */
    username: '',
    /**
     * Image Sizes
     * */
    imageSize: 36,
};
